(function () {
  function init(section) {
    const root = section.querySelector('[data-faq]');
    if (!root) return;

    const tabs = Array.from(root.querySelectorAll('.faq-question'));
    const panels = Array.from(root.querySelectorAll('.faq-answer'));
    if (!tabs.length || !panels.length) return;

    function show(i) {
      tabs.forEach((t, idx) => {
        const sel = idx === i;
        t.classList.toggle('is-active', sel);
        t.setAttribute('aria-selected', String(sel));
        const panelId = t.getAttribute('aria-controls');
        const panel = panelId ? root.querySelector('#' + panelId) : null;
        if (panel) panel.hidden = !sel;
      });
    
      // ---- Horizontal auto scroll (mobile/tablet)
      if (window.innerWidth < 1025) {
        const list = root.querySelector('.faq-questions');
        if (!list) return;
    
        const overflowX = list.scrollWidth > list.clientWidth + 1;
        if (!overflowX) return; // everything fits; no scroll
    
        const btn = tabs[i];
        const listRect = list.getBoundingClientRect();
        const btnRect = btn.getBoundingClientRect();
    
        const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const behavior = prefersReduced ? 'auto' : 'smooth';
    
        const peek = 16;       // px: space before active so next item can peek on the right
        const minRightGap = 40; // ensure a hint of the next item
        const minLeftGap  = 8;  // small padding on the left
    
        const itemStart = btn.offsetLeft; // left edge within scroll container
        const itemEnd   = itemStart + btn.offsetWidth;
        const viewStart = list.scrollLeft;
        const viewEnd   = viewStart + list.clientWidth;
    
        // Is the active item fully visible?
        const fullyVisible = btnRect.left >= listRect.left && btnRect.right <= listRect.right;
    
        if (!fullyVisible) {
          // Bring the active item near the left, leaving a small "peek"
          const target = Math.max(0, itemStart - peek);
          list.scrollTo({ left: target, behavior });
        } else {
          // If it's visible but hugging an edge, nudge so neighbors peek appropriately
          const tooCloseRight = btnRect.right > (listRect.right - minRightGap);
          const tooCloseLeft  = btnRect.left  < (listRect.left  + minLeftGap);
    
          if (tooCloseRight) {
            const delta = btnRect.right - (listRect.right - minRightGap);
            list.scrollBy({ left: delta, behavior });
          } else if (tooCloseLeft) {
            const delta = (listRect.left + minLeftGap) - btnRect.left;
            list.scrollBy({ left: -delta, behavior });
          }
        }
      }
    }
    

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => show(i));
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault(); tabs[(i + 1) % tabs.length].focus(); show((i + 1) % tabs.length);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault(); const j = (i - 1 + tabs.length) % tabs.length; tabs[j].focus(); show(j);
        }
      });
    });

    // default to first item
    show(0);
  }

  function initAll() {
    document.querySelectorAll('.faq').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
})();
